import UserDetailModel from './user-detail-model'

export default class UpdateUserResponseModel {
  public user: UserDetailModel
  public passwordReset: boolean
}
